'use client'

import Link from 'next/link'
import { useState } from 'react'
import { StaticPageShell, StaticSection } from './StaticPageShell'

export function ContactPage() {
  const [sent, setSent] = useState(false)

  return (
    <StaticPageShell
      title="Contact"
      description="Questions about orders, selling, or partnerships? Send us a message."
      narrow
    >
      <StaticSection>
        <div className="mb-6 space-y-1 text-zinc-600 dark:text-zinc-400">
          <p>
            Email:{' '}
            <a
              href="mailto:support@ctxor.com"
              className="font-medium text-zinc-900 underline dark:text-zinc-100"
            >
              support@ctxor.com
            </a>
          </p>
          <p>
            Hire creators:{' '}
            <Link href="/hire" className="font-medium text-zinc-900 underline dark:text-zinc-100">
              /hire
            </Link>
          </p>
        </div>
      </StaticSection>

      {sent ? (
        <div className="rounded-xl border border-zinc-200 bg-white p-6 dark:border-zinc-800 dark:bg-zinc-900">
          <p className="font-medium text-zinc-900 dark:text-zinc-100">Message sent</p>
          <p className="mt-1 text-zinc-600 dark:text-zinc-400">
            Thanks — we will get back to you as soon as we can.
          </p>
          <button
            type="button"
            onClick={() => setSent(false)}
            className="mt-4 text-sm font-medium text-zinc-900 underline dark:text-zinc-100"
          >
            Send another message
          </button>
        </div>
      ) : (
        <form
          className="space-y-4 rounded-xl border border-zinc-200 bg-white p-6 dark:border-zinc-800 dark:bg-zinc-900"
          onSubmit={(e) => {
            e.preventDefault()
            setSent(true)
          }}
        >
          <div>
            <label htmlFor="contact-name" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-zinc-500">
              Name
            </label>
            <input
              id="contact-name"
              name="name"
              required
              className="w-full rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 text-sm text-zinc-900 outline-none ring-zinc-400 focus:ring-2 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-100"
            />
          </div>
          <div>
            <label htmlFor="contact-email" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-zinc-500">
              Email
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              className="w-full rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 text-sm text-zinc-900 outline-none ring-zinc-400 focus:ring-2 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-100"
            />
          </div>
          <div>
            <label htmlFor="contact-message" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-zinc-500">
              Message
            </label>
            <textarea
              id="contact-message"
              name="message"
              required
              rows={5}
              className="w-full resize-y rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 text-sm text-zinc-900 outline-none ring-zinc-400 focus:ring-2 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-100"
            />
          </div>
          <button
            type="submit"
            className="inline-flex rounded-lg bg-zinc-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-zinc-700 dark:bg-zinc-100 dark:text-zinc-900 dark:hover:bg-zinc-300"
          >
            Send message
          </button>
        </form>
      )}
    </StaticPageShell>
  )
}
